import type { ParentType } from '@risksmart-app/domain/src/types/consts/parent-type';
import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';

import type { AssessmentTypeEnum } from '../../../assessments/types';

export type TestResultFieldIds = Extract<
  ParentType,
  | 'test_result'
  | 'control_test_internal_audit_result'
  | 'control_test_oversight_result'
>;

export const getParentType = (
  assessmentMode?: AssessmentTypeEnum
): TestResultFieldIds => {
  switch (assessmentMode) {
    case 'internal_audit_report':
      return Parent_Type_Enum.ControlTestInternalAuditResult;
    case 'oversight_assessment':
      return Parent_Type_Enum.ControlTestOversightResult;
    case 'rating':
    default:
      return Parent_Type_Enum.TestResult;
  }
};
